// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"25f230a6","488":"21c0482c","796":"9e1b1a7d"}[chunkId] + ".chunk.js";
};